import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock, faUserPlus, faImage, faEnvelope, faBell, faLanguage, faShieldAlt, faInfoCircle, faUtensils } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const settingsItems = [
    { title: 'Tafel opstelling maken', icon: faUtensils, color: '#007bff', path: '/settings/tafelopstelling' },
    { title: 'Tijdsloten', icon: faLock, color: '#28a745', path: '/settings/TimeslotManager' },
    { title: 'Medewerker Toevoegen', icon: faUserPlus, color: '#fd7e14', path: '/settings/RegistrationLinkDashboard' },
    { title: 'Logo Uploaden', icon: faImage, color: '#6f42c1', path: '/settings/logoUpload' }, // Nieuwe item voor logo upload
];

const SettingsPage = () => {
    return (
        <Container fluid className="mt-1 pt-2">
            <Row>
                <h2 className="mb-4">Instellingen</h2>
                {settingsItems.map((item, index) => (
                    <Col key={index} xs={12} sm={12} md={6} lg={6} className="mb-4">
                        <Link to={item.path} style={{ textDecoration: 'none' }}>
                            <Card
                                className="w-100 d-flex justify-content-center align-items-center py-4"
                                style={{ backgroundColor: item.color, color: 'white' }}
                            >
                                <div className="d-flex align-items-center w-100 px-4">
                                    <FontAwesomeIcon icon={item.icon} className="me-3" size="lg" style={{ color: 'white' }} />
                                    <span className="font-weight-bold" style={{ color: 'white' }}>{item.title}</span>
                                    <FontAwesomeIcon icon="chevron-right" className="ms-auto" size="lg" style={{ color: 'white' }} />
                                </div>
                            </Card>
                        </Link>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default SettingsPage;
